// extracted by mini-css-extract-plugin
module.exports = {"image":"MultipurposeBlock_image__4Xk8d"};